import React, { useEffect, useState } from 'react';
import './FeaturesListAdd.css';

const FeaturesList = ({
  title = 'Add Plan Features',
  defaultSelectedOptions = [],
  allFeatures = [],
  onChange,
  validators = [],
  error = '',
}) => {
  const [selectedOptions, setSelectedOptions] = useState(defaultSelectedOptions);
  const [errors, setErrors] = useState([]);
  const [isChecked, setIsChecked] = useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    if (Array.isArray(defaultSelectedOptions) && defaultSelectedOptions.length > 0) {
      setSelectedOptions(prev => {
        if (prev.length === defaultSelectedOptions.length && prev.every((v, i) => v === defaultSelectedOptions[i])) {
          return prev;
        }
        return defaultSelectedOptions;
      });
    }
  }, [defaultSelectedOptions]);

  useEffect(() => {
    if (hasInteracted && validators?.length > 0) {
      const validationResults = validators
        .map((validator) => validator(selectedOptions))
        .filter((result) => result !== true);

      setErrors(prev => {
        if (validationResults.length === 0 && prev.length === 0) return prev;
        return validationResults;
      });
    } else {
      setErrors(prev => (prev.length === 0 ? prev : []));
    }
  }, [selectedOptions, validators, hasInteracted]);

  const handleCheckboxChange = (option) => {
    let updatedFeatures;
    if (selectedOptions.includes(option.value)) {
      updatedFeatures = selectedOptions.filter(value => value !== option.value);
    } else {
      updatedFeatures = [...selectedOptions, option.value];
    }
    setHasInteracted(true);
    setSelectedOptions(updatedFeatures);
    onChange?.(updatedFeatures);
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    const updatedFeatures = isChecked
      ? allFeatures.map(option => option.value)
      : [];

    setHasInteracted(true);
    setSelectedOptions(updatedFeatures);
    onChange?.(updatedFeatures);
  };

  // 👇 Final errors array
  const displayErrors = error ? [error] : errors;

  return (
    <div className='FeaturesListAdd-box-container'>
      <div className='FeaturesListAdd-heading'>
        <input
          className='table-selectbox main-checkbox'
          type="checkbox"
          onChange={handleSelectAllChange}
          checked={selectedOptions.length > 0 && selectedOptions.length === allFeatures.length}
        />
        <span className='common-text ftw-5 fts-18 black'>{title}</span>
      </div>
      <div className='features-list'>
        {allFeatures.map((option, index) => (
          <div key={index} className='new-features-items'>
            <input
              className="table-selectbox sub-checkbox"
              type="checkbox"
              checked={selectedOptions.includes(option.value)}
              onChange={() => handleCheckboxChange(option)}
            />
            <span className='common-text ftw-4 fts-15' style={{ color: 'var(--Icons, #535353)' }}>{option.label}</span>
          </div>
        ))}
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12 fetaure-list-error">
          {displayErrors}
        </div>
      )}
    </div>
  );
};

export default FeaturesList;